const INIT_PANELS = "INIT_PANELS";
const INIT_GRIDS = "INIT_GRIDS";
const INIT_MODALS = "INIT_MODALS";
const CLOSE_MODALS = "CLOSE_MODALS";
const RESET_MODALS = "RESET_MODALS";
const SET_MODALS_PARAM = "SET_MODALS_PARAM";
const SET_PARAM_PANELS = "SET_PARAM_PANELS";
const SET_GRIDS_PARAM = "SET_GRIDS_PARAM";
const UPDATE_PANELS = "UPDATE_PANELS";

const SET_LOCALE = "SET_LOCALE";

// 初始化tab页内容
const initPanels = (key, tab, activeKey, param) => {
  return {
    type: INIT_PANELS,
    key,
    tab,
    activeKey,
    param,
  };
};

const updatePanelsInfo = (panels, activeKey) => {
  return {
    type: UPDATE_PANELS,
    panels,
    activeKey,
  };
};

// tab页 param设置
const setParamPanels = (key, param) => {
  return {
    type: SET_PARAM_PANELS,
    key,
    param,
  };
};

// 初始化表格相关
const initGrids = (key, param, handler, context) => {
  return {
    type: INIT_GRIDS,
    key,
    param,
    handler,
    context,
  };
};

const initModals = (key, param, context) => {
  return {
    type: INIT_MODALS,
    key,
    visible: !0,
    param,
    context,
  };
};

const closeModals = () => {
  return {
    type: CLOSE_MODALS,
    visible: !1,
  };
};

const resetModals = (key, handler) => {
  return {
    type: RESET_MODALS,
    key,
    handler,
  };
};

const setModalsParam = (key, param) => {
  return {
    type: SET_MODALS_PARAM,
    key,
    param,
  };
};

const setGridsParam = (param) => {
  return {
    type: SET_GRIDS_PARAM,
    param,
  };
};

/**
 * 国际化配置
 */
const setLocaleConfig = (locale) => {
  console.log(locale);
  return {
    type: SET_LOCALE,
    locale,
  };
};

export {
  INIT_PANELS,
  initPanels,
  INIT_GRIDS,
  initGrids,
  INIT_MODALS,
  initModals,
  CLOSE_MODALS,
  closeModals,
  RESET_MODALS,
  resetModals,
  SET_MODALS_PARAM,
  SET_PARAM_PANELS,
  setModalsParam,
  setParamPanels,
  SET_GRIDS_PARAM,
  setGridsParam,
  UPDATE_PANELS,
  updatePanelsInfo,
  SET_LOCALE,
  setLocaleConfig,
};



// WEBPACK FOOTER //
// ./src/AntD/state/action/comAction.js